import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { EDIT } from "const"
import { hasAccess } from "client/utils"
import {
    PRM_QID_PRODUCT,
    StoreType,
    QidDatapointGroup,
    setQidDatapointDelete,
    setQidDatapointDeleteExisting,
    addModal,
} from "client/store"
import {
    Container,
    FormGroup,
    Label,
    LinkButton,
    Table,
} from "client/components"
import {
    Datapoint,
    DatapointDetails,
    DatapointTitle,
    DatapointButtons,
} from "./styled"

import Columns from "./columns"
import ConfirmDelete from "./confirmDelete"
import Edit from "../edit"

const List = () => {
    const datapointList = useSelector((state: StoreType) => state.qidDatapoint.datapointList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const productEditAccess = hasAccess(PRM_QID_PRODUCT, EDIT)

    const columns = Columns(false)
    const nestedColumns = Columns(true)

    const clearMarkedToDelete = () => {
        dispatch(setQidDatapointDeleteExisting([]))
    }

    return (
        <Container>
            {
                datapointList.map((row) => {
                    const datapointGroup = row as QidDatapointGroup
                    const { parents, isNested, tableView } = datapointGroup
                    const { model, safetyFunction, option } = parents
                    const key = `model_${model ? model.id : "null"}`
                                + `_safetyFunction_${safetyFunction ? safetyFunction.id : "null"}`
                                + `_option_${option ? option.id : "null"}`

                    return (
                        <Datapoint key={key}>
                            <DatapointDetails>
                                {
                                    model && (
                                        <FormGroup inline>
                                            <Label>{`${lang.model}:`}</Label>
                                            <DatapointTitle>{model.name}</DatapointTitle>
                                        </FormGroup>
                                    )
                                }
                                {
                                    safetyFunction && (
                                        <FormGroup inline>
                                            <Label>{`${lang.safetyFunction}:`}</Label>
                                            <DatapointTitle>{safetyFunction.name}</DatapointTitle>
                                        </FormGroup>
                                    )
                                }
                                {
                                    option && (
                                        <FormGroup inline>
                                            <Label>{`${lang.option}:`}</Label>
                                            <DatapointTitle>{option.name}</DatapointTitle>
                                        </FormGroup>
                                    )
                                }

                                {
                                    productEditAccess && (
                                        <DatapointButtons>
                                            <LinkButton onClick={() => {
                                                dispatch(addModal({
                                                    key: "editDatapoint",
                                                    content: <Edit
                                                        modelId={model ? model.id : null}
                                                        safetyFunctionId={safetyFunction ? safetyFunction.id : null}
                                                        optionId={option ? option.id : null}
                                                        action="edit"
                                                    />,
                                                    onClose: clearMarkedToDelete,
                                                }))
                                            }}
                                            >
                                                {lang.edit}
                                            </LinkButton>
                                            <LinkButton onClick={() => {
                                                dispatch(addModal({
                                                    key: "copyDatapoint",
                                                    content: <Edit
                                                        modelId={model ? model.id : null}
                                                        safetyFunctionId={safetyFunction ? safetyFunction.id : null}
                                                        optionId={option ? option.id : null}
                                                        action="copy"
                                                    />,
                                                    onClose: clearMarkedToDelete,
                                                }))
                                            }}
                                            >
                                                {lang.copy}
                                            </LinkButton>
                                            <LinkButton onClick={() => dispatch(setQidDatapointDelete(datapointGroup))}>
                                                {lang.delete}
                                            </LinkButton>
                                        </DatapointButtons>
                                    )
                                }
                            </DatapointDetails>

                            <Table
                                columns={isNested ? nestedColumns : columns}
                                dataList={tableView.list}
                                dataIds={tableView.ids}
                                rowSize="sm"
                                showPagination={false}
                                showBottom={false}
                            />
                        </Datapoint>
                    )
                })
            }

            <ConfirmDelete />
        </Container>
    )
}
export default List
